import { useQuery, UseQueryResult } from 'react-query';
import { getTiledeskDashboardAccess } from './api.ts';
import { ITiledeskDashboardAccess } from './types.ts';

export enum TiledeskHook {
  DashboardAccess = 'tiledeskDashboardAccess',
}

/**
 * `forIframe`: query própria sem cache, para o iframe sempre montar com um token
 * recém-emitido e nunca trocar de `src` depois (o que recarregaria o painel).
 */
export function useTiledeskDashboardAccess(forIframe = false): UseQueryResult<ITiledeskDashboardAccess> {
  return useQuery([TiledeskHook.DashboardAccess, forIframe], getTiledeskDashboardAccess, {
    staleTime: forIframe ? Infinity : 5 * 60 * 1000,
    cacheTime: forIframe ? 0 : 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    // Convênio sem chat responde 404: não é erro, o menu só não aparece.
    retry: false,
  });
}
